import React, {Component} from 'react';
import './App.css';
import {library} from '@fortawesome/fontawesome-svg-core';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {BrowserRouter, Route} from 'react-router-dom';

import AppContent from './components/AppContent';
import Header from './components/Header';
import HowTo from './components/Howto';
import About from './components/About';
import Footer from './components/Footer';
import {connect} from 'react-redux';
import {addLocaleData, IntlProvider} from 'react-intl';
import locale_en from 'react-intl/locale-data/en';
import locale_ar from 'react-intl/locale-data/ar';
import messages_en from './Translations/en.json';
import messages_ar from './Translations/ar.json';

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Localization
addLocaleData([...locale_en, ...locale_ar]);
const messages = {
	'ar': messages_ar,
	'en': messages_en,
};

// Get Client Language.
//const language = navigator.language.split(/[-_]/)[0];

library.add(fab);

class App extends Component {

	componentDidMount() {
		let loadingPage = document.getElementById('loading-page');
		loadingPage.style.display = 'none'
	}

	render() {
		return (
				<IntlProvider locale={this.props.language} messages={messages[this.props.language]}>

					<BrowserRouter>

						<Header/>


						<Route exact path={'/'} component={() => <AppContent/>}/>

						<Route path={'/howto'} component={HowTo}/>
						<Route path={'/features'} component={About}/>


						<Footer/>
						<ToastContainer rtl={this.props.language === 'ar' && true} position={this.props.language === 'ar' ? 'top-left' : 'top-right'}/>
					</BrowserRouter>
				</IntlProvider>
		);
	}
}

function mapStateToProps(state) {
	return {
		language: state.TranslationReducer.language,
	};
}

export default connect(mapStateToProps)(App);
